<template>
  <div class="ll-law-article">
    <div v-if="!isloading" class="ll-law-article_content">
      <div v-for="(title, titleIndex) in _titleList" :key="titleIndex">
        <LvText
          bold
          class="mb-8"
          :class="{
            'ml-16': title === 'chapter',
            'ml-24': title === 'division',
            'ml-32': title === 'section',
            'ml-40': title === 'sub_section',
          }"
        >
          {{ articleContent[title] }}
        </LvText>
        <LvDivider marginBottom="8px" marginTop="8px" />
      </div>

      <div :id="`article${articleContent.id}`" class="chapter-content">
        <div
          class="article-title"
          :class="{ 'mb-16': !_isShowTaskCreateBtn && !_isShowHistoryBtn }"
        >
          <div class="article-title__item">
            <LvText h4 bold blue>
              {{ articleContent.no_text }}
              <TextChip
                v-if="_updateVersion"
                thin
                hasBg
                noWrap
                yellow
                fontSizeXs
                class="ml-20"
                :textLabel="$t('更新')"
              />
            </LvText>
          </div>
          <div class="article-title__item ml-8">
            <WsButton001
              v-if="_isShowTaskCreateBtn"
              mediumButton
              leading-icon="icon-add-assignment"
              @click="$_onClickCreateTask()"
            >
              <LvText h6 noWrap white>{{ $t('建立任務') }}</LvText>
            </WsButton001>
            <WsButton001
              v-if="_isShowHistoryBtn"
              out-line
              medium-button
              class="ml-8"
              @click="popUpOpen(articleContent)"
            >
              <LvText h6 noWrap lightGray>{{ $t('沿革') }}</LvText>
            </WsButton001>
          </div>
        </div>
        <div class="article-content-wrap">
          <LvArticleContent
            :content="articleContent.content"
            :richContent="articleContent.rich_content"
          />
          <CommentCollapseCard
            v-if="articleContent.ll_comment"
            :title="$t('ESGoal評析')"
            :value="articleContent"
            :date="articleContent.updated_at"
          >
            <template v-slot:law-icons>
              <TextIconList
                v-if="articleContent.effects.length > 0"
                :icon-list="articleContent.effects"
              />
            </template>
            <template v-slot:rwo-cards>
              <RowButtonCard
                v-if="_scopePayAsk"
                :title="$t('有任何疑問嗎？')"
                :content-text="$t('如果你對於ESGoal評析或法條內容有任何疑問請點擊諮詢按鈕')"
              >
                <template v-slot:btn>
                  <WsButton001
                    leading-icon="icon-advisory-outline"
                    primary
                    width-stretch
                    @click="$_payAskPopupOpen()"
                  >
                    {{ $t('諮詢') }}
                  </WsButton001>
                </template>
              </RowButtonCard>
            </template>
          </CommentCollapseCard>
          <CollapseContainer
            v-if="_hasTaskSubscribed && _scopeReadTaskAble && articleContent.task"
            title="相關任務"
          >
            <template v-slot:cardLists>
              <EventCardList
                v-if="_scopeReadTaskAble && articleContent.task"
                :event-list="_eventCardList"
                :button="_scopeCreateTaskAble && !articleContent.task"
              />
            </template>
          </CollapseContainer>
          <slot name="card-lists" />
        </div>
      </div>
      <PopUp v-if="active.popup" :pop-up-active="active.popup" :notice="true" @click="popUpClose()">
        <div class="popup-title">
          <p class="title">
            {{ $t('沿革') }}- {{ actData ? actData.last_version.name : '' }}
            {{ popupNotext }}
          </p>
        </div>
        <DotLoading v-if="loading.popup" />
        <div v-else class="popup-content">
          <div class="dropdown-wrap">
            <p class="dropdown-title">
              {{ $t('選擇版本') }}
            </p>
            <DropdownMenuButton
              v-model="actVersionsDoprdownItems.selectedMenuItem"
              :dropdown-menu-item="actVersionsDoprdownItems.menuItems"
              outline
              @click="contentTabOnclick()"
            />
          </div>
          <div class="tab-content">
            <p class="tab-title">
              {{ $t('修正條文前後差異') }}
            </p>
            <div
              v-if="ingVersionIndex < actVersionsDoprdownItems.menuItems.length"
              class="text-card-list"
            >
              <LvTextCard
                v-if="ingVersionIndex + 1 < ingArticleVersions.versions.length"
                outline
                original
                leading-icon="icon-warning"
                :card-header="$t('修正前條文')"
                :card-content="ingArticleVersions.versions[ingVersionIndex + 1].content"
                :cart-chapter-title="ingArticleVersions.versions[ingVersionIndex + 1].no_text"
                class="text-card-list__card"
              />
              <LvTextCard
                outline
                original
                leading-icon="icon-check-circle-outline"
                :card-header="$t('修正後條文')"
                :card-content="ingArticleVersions.versions[ingVersionIndex].content"
                :cart-chapter-title="ingArticleVersions.versions[ingVersionIndex].no_text"
                class="text-card-list__card"
              />
            </div>
            <LvTextCard
              v-if="
                ingVersionIndex < actVersionsDoprdownItems.menuItems.length &&
                ingVersionIndex < ingArticleVersions.versions.length
              "
              class="mt-20"
              :diff-text="
                law_diff(
                  ingArticleVersions.versions[ingVersionIndex + 1].content,
                  ingArticleVersions.versions[ingVersionIndex].content,
                )
              "
              :card-header="$t('修正差異')"
              leading-icon="icon-edit"
              original
            />
            <LvTextCard
              v-else
              outline
              class="mt-20"
              :card-content="ingArticleVersions.versions[ingVersionIndex].content"
              :card-header="$t('現行條文')"
              leading-icon="icon-check-circle-outline"
              original
            />
            <CollapseCard
              v-if="ingArticleVersions.versions[ingVersionIndex].official_comment"
              trailing-icon="icon-link"
              :card-content="ingArticleVersions.versions[ingVersionIndex].official_comment"
              :card-link="ingArticleVersions.versions[ingVersionIndex].reference_link"
              :card-title="$t('立法理由')"
            >
              <div
                v-if="
                  ingArticleVersions.versions[ingVersionIndex].attaches[0] &&
                  ingArticleVersions.versions[ingVersionIndex].attaches.length > 0
                "
                class="download-file"
              >
                <LvFileList
                  twoItem
                  :value="ingArticleVersions.versions[ingVersionIndex].attaches"
                />
              </div>
            </CollapseCard>
            <CommentCard
              :ll-content="ingArticleVersions.versions[ingVersionIndex].ll_comment"
              :effect-icon="ingArticleVersions.versions[ingVersionIndex].effects"
            />
          </div>
        </div>
      </PopUp>
      <PopUp
        v-if="active.pay_ask_active"
        title="一般法律諮詢"
        :clickOutsideClose="false"
        :pop-up-active="active.pay_ask_active"
        @click="$_payAskPopupClose()"
      >
        <LlCancelPopupContent v-if="!active.giveUpPayAsk && !active.send">
          <ValidationObserver ref="formObserver">
            <InputListCard>
              <div class="input-item">
                <LlState
                  v-model="payAskData.name"
                  :title="fields.name.label"
                  :type="fields.name.type"
                  :placeholder="fields.name.placeholder"
                  :rules="fields.name.rules"
                  :is-required="fields.name.isRequired"
                />
              </div>
              <div class="multiple-input-item">
                <div class="input-item ll-law-article__pay-ask-contact-way">
                  <LlState
                    v-model="payAskData.contact_way"
                    :title="fields.contact_way.label"
                    :type="fields.contact_way.type"
                    :dropdown-menu-items="fields.contact_way.menuItems"
                    :rules="fields.contact_way.rules"
                    :is-required="fields.contact_way.isRequired"
                    :default-value="fields.contact_way.defaultValue"
                    :is-outline="fields.contact_way.isOutline"
                  />
                </div>
                <div class="input-item ll-law-article__pay-ask-input-full">
                  <LlState
                    v-if="payAskData.contact_way === 'tel'"
                    v-model="payAskData.tel"
                    :title="fields.tel.label"
                    :type="fields.tel.type"
                    :placeholder="fields.tel.placeholder"
                    :rules="fields.tel.rules"
                    :is-required="fields.tel.isRequired"
                  />
                  <LlState
                    v-if="payAskData.contact_way === 'email'"
                    v-model="payAskData.email"
                    :title="fields.email.label"
                    :type="fields.email.type"
                    :placeholder="fields.email.placeholder"
                    :rules="fields.email.rules"
                    :is-required="fields.email.isRequired"
                  />
                </div>
              </div>
              <div class="multiple-input-item">
                <div class="input-item ll-law-article__pay-ask-input-full">
                  <LlState
                    v-model="payAskData.subject"
                    :title="fields.subject.label"
                    :type="fields.subject.type"
                    :placeholder="fields.subject.placeholder"
                    :rules="fields.subject.rules"
                    :is-required="fields.subject.isRequired"
                    :default-value="fields.subject.defaultvalue"
                  />
                </div>
              </div>
              <div class="input-item">
                <div class="input">
                  <LlState
                    v-model="payAskData.remark"
                    :title="fields.remark.label"
                    :type="fields.remark.type"
                    :rules="fields.remark.rules"
                    :is-required="fields.remark.isRequired"
                    :placeholder="fields.remark.placeholder"
                    :min-height="134"
                  >
                    <template v-slot:button>
                      <UploadFileButton
                        v-model="payAskData.attaches"
                        text
                        :factory="_currentFactoryId"
                        :text-label="$t('附件')"
                        url="legal_inquiry/attach"
                        multiple
                      />
                    </template>
                    <template v-if="payAskData.attaches.length > 0" v-slot:attaches>
                      <div>
                        <LlFileList
                          :attaches="payAskData.attaches"
                          outline
                          upload
                          narrow
                          two-item
                          showDeleteBtn
                          :margin-top="20"
                          @delete-file="$_deleteAttach($event)"
                        />
                      </div>
                    </template>
                  </LlState>
                </div>
              </div>
            </InputListCard>
          </ValidationObserver>
          <template v-slot:buttons>
            <WsButton001 width200 out-line @click="$_payAskGiveUp()">
              {{ $t('取消') }}
            </WsButton001>
            <WsButton001 :isloading="loading.pay_ask" @click="$_payAskSubmit()">
              {{ $t('送出') }}
            </WsButton001>
          </template>
        </LlCancelPopupContent>
        <LlCancelPopupContent v-if="active.giveUpPayAsk && !active.send" cancel-text="確定捨棄嗎？">
          <template v-slot:buttons>
            <WsButton001 outLine @click="$_payAskContinue()">
              {{ $t('取消') }}
            </WsButton001>
            <WsButton001 @click="$_payAskPopupClose()">
              {{ $t('確定') }}
            </WsButton001>
          </template>
        </LlCancelPopupContent>
        <LlCancelPopupContent v-if="active.send">
          <LlSos v-if="active.send" />
        </LlCancelPopupContent>
      </PopUp>
      <PopUp v-else :pop-up-active="active.pay_ask_active" @click="$_payAskPopupClose()" />
    </div>
    <div v-else class="ll-law-article_isloading">
      <SkeletonAnimate class="skekete title" />
      <div class="collapse-card_isloading-content">
        <SkeletonAnimate class="skekete skekete1" />
        <SkeletonAnimate class="skekete skekete1" />
        <SkeletonAnimate class="skekete skekete2" />
        <SkeletonAnimate class="skekete skekete1" />
        <SkeletonAnimate class="skekete skekete2" />
      </div>
    </div>
    <LvFlowCreateTask ref="LvFlowCreateTask" :createQuery="_createTaskQuery" />
  </div>
</template>
<script>
import config from '@/__config';
import S_Scope from '@/service/api/v1/scope';
import serviceArticle from '@/service/api/v1/article';
import scope from '@/service/api/v1/scope';
import H_file from '@/helpers/file';
import H_common from '@/helpers/common';

export default {
  name: 'LlLawArticle',
  props: {
    isloading: {
      type: Boolean,
      default: false,
    },
    articleContent: {
      type: Object,
      default() {
        return {};
      },
    },
    actData: {
      type: Object,
      default() {
        return {};
      },
    },
    taskCreatable: {
      type: Boolean,
      default: true,
    },
    historyReadable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      active: {
        popup: false,
        pay_ask_active: false,
        giveUpPayAsk: false,
        send: false,
      },
      loading: {
        pay_ask: false,
        popup: false,
      },
      popupNotext: null,
      ingArticleVersions: {
        versions: null,
      },
      ingVersionIndex: null,
      actVersionsDoprdownItems: {
        placeholder: '',
        selectedMenuItem: 'all',
        menuItems: [
          {
            id: 'all',
            textLabel: this.$t('不限期間'),
          },
        ],
      },
      license: {
        tags: [{ icon: 'icon-water', text: '水污染防治' }],
        title: '防火檢查記錄表',
        spec: [
          { title: '證號', text: '操證字第H1716-06號' },
          {
            title: '核准函號',
            text: '桃園市政府2015.09.16府環空字第1040243226號函',
          },
          { title: '效期', text: '2015.06.03 - 2020.06.02' },
        ],
        btnIcon: 'icon-water',
        btnText: '按鈕按鈕按鈕',
      },
      payAskData: {
        name: '',
        email: '',
        tel: '',
        subject: this.$t('選項一內容'),
        attaches: [],
        remark: '',
      },
      fields: {
        name: {
          label: this.$t('聯絡人姓名'),
          type: 'text',
          isRequired: true,
          placeholder: this.$t('輸入'),
          rules: 'required',
        },
        contact_way: {
          label: this.$t('聯絡方式'),
          type: 'dropdown',
          isRequired: true,
          defaultValue: 'email',
          isOutline: true,
          menuItems: [
            {
              id: 'tel',
              textLabel: this.$t('手機'),
            },
            {
              id: 'email',
              textLabel: this.$t('信箱'),
            },
          ],
        },
        tel: {
          label: this.$t('手機號碼'),
          type: 'text',
          isRequired: true,
          rules: 'required|numeric',
          placeholder: '0900-000-000',
        },
        email: {
          label: this.$t('信箱'),
          type: 'text',
          isRequired: true,
          rules: 'required|email',
          placeholder: 'aa@xxxxxx.com',
        },
        subject: {
          label: this.$t('主旨'),
          type: 'text',
          placeholder: this.$t('輸入'),
        },
        remark: {
          label: this.$t('簡述'),
          type: 'textarea',
          isRequired: true,
          rules: 'required',
          placeholder: this.$t('輸入'),
        },
      },
    };
  },
  computed: {
    _currentFactoryId() {
      return this.$route.params.factoryId;
    },
    _currentUser() {
      return this.$store.state.stone_auth.currentUser;
    },
    _scopeReadTaskAble() {
      return scope.$_isAvailable(['task-read']) || scope.$_isAvailable(['task-read-all']);
    },
    _scopeCreateTaskAble() {
      return scope.$_isAvailable(['task-create']);
    },
    _eventCardList() {
      let eventCardList = [];
      if (this.articleContent.task && this._scopeReadTaskAble) {
        eventCardList.push({
          id: this.articleContent.task.id,
          type: 'task',
          titleSize: 0,
        });
      }
      return eventCardList;
    },
    _updateVersion() {
      const actVersionId = this.actData.last_version.id;
      return this.articleContent.act_version
        ? this.articleContent.act_version.id === actVersionId
        : this.articleContent.article.act_version.id == actVersionId;
    },
    _scopePayAsk() {
      return config.build.esgoalContact && S_Scope.$_isAvailable(['act-inquiry']);
    },
    _scopeCreateTask() {
      return S_Scope.$_isAvailable(['task-create']);
    },
    _titleList() {
      const titleKeys = ['part', 'chapter', 'division', 'section', 'sub_section'];
      return titleKeys.filter(key => this.articleContent[key]);
    },
    _hasTaskSubscribed() {
      return H_common.hasSubscription('tasks');
    },
    _isShowTaskCreateBtn() {
      return (
        this._hasTaskSubscribed &&
        this.taskCreatable &&
        !this.articleContent.task &&
        this._scopeCreateTask &&
        this._updateVersion
      );
    },
    _isShowHistoryBtn() {
      return (
        this.historyReadable &&
        this.articleContent.prev_version &&
        this.articleContent.prev_version.length > 0
      );
    },
    _createTaskQuery() {
      return {
        article_version: this.articleContent.id,
        from: 'act',
      };
    },
  },
  methods: {
    law_diff(old_law, new_law) {
      let JsDiff = require('diff');
      let diff = JsDiff.diffChars(old_law, new_law);
      return diff;
    },
    contentTabOnclick() {
      this.ingVersionIndex = parseInt(this.actVersionsDoprdownItems.selectedMenuItem);
    },
    async popUpOpen(articleContent) {
      this.loading.popup = true;
      this.active.popup = true;
      await this.getArticleVersion(articleContent.article.id);
      this.popupNotext = articleContent.no_text;
      this.loading.popup = false;
    },
    popUpClose() {
      this.active.popup = false;
    },
    async getArticleVersion(id) {
      const params = {
        order_by: 'announce_at',
        order_way: 'desc',
        article: id,
      };
      const res = await serviceArticle.articleVersionIndex(this._currentFactoryId, params);
      this.ingArticleVersions.versions = res.data.map(rawData => {
        return {
          ...rawData,
          attaches: H_file.setTempFileShowInModule(rawData.attaches),
        };
      });
      this.ingVersionIndex = 0;
      this.$_getActVersionsDropdownItems(this.ingArticleVersions.versions);
    },
    $_getActVersionsDropdownItems(versions) {
      const _versions = [...versions];
      let dropdownItems = _versions.map((version, versionIndex) => {
        return {
          id: versionIndex.toString(),
          textLabel: this.$_getdateFormat(version.announce_at),
        };
      });
      dropdownItems = dropdownItems.slice(0, dropdownItems.length - 1);
      this.actVersionsDoprdownItems.menuItems = dropdownItems;
      this.actVersionsDoprdownItems.selectedMenuItem = dropdownItems[0].id;
    },
    $_onClickCreateTask() {
      const LvFlowCreateTask = this.$refs.LvFlowCreateTask;
      if (!LvFlowCreateTask) return;
      LvFlowCreateTask.start();
    },
    $_getdateFormat(time) {
      if (!time) return;
      return this.$moment(time).format('YYYY-MM-DD');
    },
    $_payAskPopupOpen() {
      const is_scope = scope.$_invalidPopupOpen('act-inquiry', 'action');
      if (!is_scope) {
        return;
      }
      this.$_clearPayAskData();
      // this.payAskData.subject = this.$t("選項一內容");
      this.active.pay_ask_active = true;
      this.active.giveUpPayAsk = false;
      this.active.send = false;
    },
    $_payAskPopupClose() {
      this.active.pay_ask_active = false;
    },
    async $_payAskSubmit() {
      const isValidate = await this.$refs.formObserver.validate();
      if (!isValidate) {
        return;
      }
      this.loading.pay_ask = true;
      let attaches = this.payAskData.attaches.map(img => img.url);
      let payAskData = {
        contact_for: this.payAskData.subject,
        contact_person: this.payAskData.name,
        contact_way: this.payAskData.contact_way,
        tel: this.payAskData.tel,
        email: this.payAskData.email,
        remark: this.payAskData.remark,
        attaches: attaches,
        user: this._currentUser.id,
        factory: this._currentFactoryId,
        user_payload: {
          id: this._currentUser.id,
          name: this._currentUser.name,
        },
      };
      try {
        await this.$axios.post(`/legal_inquiry`, payAskData);
        this.loading.pay_ask = false;
        this.active.send = true;
      } catch (err) {
        this.loading.pay_ask = false;
        alert(this.$t('法律諮詢送出失敗'));
      }
    },
    $_payAskGiveUp() {
      let payAskContent = false;
      for (let dataKey in this.payAskData) {
        if (this.payAskData[dataKey]) {
          payAskContent = true;
        }
      }
      if (payAskContent) {
        this.active.giveUpPayAsk = true;
        return;
      }
      this.$_payAskPopupClose();
    },
    $_payAskContinue() {
      this.active.giveUpPayAsk = false;
    },
    $_clearPayAskData() {
      this.payAskData = {
        name: '',
        email: '',
        tel: '',
        subject: '',
        attaches: [],
        remark: '',
      };
    },
    $_deleteAttach($event) {
      this.payAskData.attaches.splice($event, 1);
    },
  },
};
</script>
<style lang="scss">
@import '@/assets/scss/component/ll-law-article';
</style>
